import React, { createContext, FC, useContext } from 'react';
import { NodeExecutionResult } from '@glueapp/graph-types';

export const NodeExecutionResultContext = createContext<NodeExecutionResult | undefined>(undefined);

interface NodeExecutionResultContextProviderProps {
    executionResult: NodeExecutionResult | undefined;
    children: React.ReactNode;
}

export const NodeExecutionResultContextProvider: FC<NodeExecutionResultContextProviderProps> = props => {
    return <NodeExecutionResultContext.Provider value={props.executionResult}>{props.children}</NodeExecutionResultContext.Provider>;
};

export function useNodeExecutionResult() {
    return useContext(NodeExecutionResultContext);
}
